<template>
  <div class="wl-results" v-if="doc">
    <results-bar :doc="doc" @loadSummary="loadSummary" @loadUser="loadUser"></results-bar>
    <results-summary v-if="summary" :id="doc.id" :summaryMode="summaryMode"></results-summary>
    <results-user v-if="!summary" :uid="currentUser"></results-user>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { store } from '@/store.js'
import {
  ResultsSummary,
  ResultsUser,
  ResultsBar
} from "@/components/results/keywords";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ResultFunctionality",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null
    };
  },
  components: {
    ResultsSummary,
    ResultsUser,
    ResultsBar
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState(["exFunctionality"])
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
    },
    getExercise() {
      let ref = fb.keywordsExCollection.where("pid", "==", this.doc.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          let users = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            users.push(post.uid);
            
            post.list.forEach((item) => {
              items.push(item);
            });
          });
          if (items) {
            // this.exList = items;
             store.commit('setExKeywords', items)
          }
          if (users) {
            this.userList = users;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
